import { render, staticRenderFns } from "./mobileResort-page.vue?vue&type=template&id=58e28756&scoped=true"
import script from "./mobileResort-page.vue?vue&type=script&lang=js"
export * from "./mobileResort-page.vue?vue&type=script&lang=js"
import style0 from "./mobileResort-page.vue?vue&type=style&index=0&id=58e28756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e28756",
  null
  
)

export default component.exports